import { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'

export default function AllowContent(countryList: string[], defaultBehavior: boolean) {
  const [renderable, setRenderable] = useState(defaultBehavior)
  const [cookies] = useCookies(['country_code'])
  useEffect(() => {
    setRenderable(checkVisibility(cookies.country_code, countryList, defaultBehavior))
  }, [cookies.country_code, countryList, defaultBehavior])

  return renderable
}

const checkVisibility = (country_code: string | undefined, countryList: string[], defaultBehavior: boolean) => {
  const neg = '!'
  if (country_code !== undefined) {
    if (countryList.includes('*')) {
      if (countryList.includes(neg.concat(country_code.toLowerCase()))) return false
      return true
    }
    if (countryList.includes(country_code.toLowerCase())) return true
  }
  return defaultBehavior
}
